import React, { useEffect, useState } from "react"

import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"
// import "../../../../assets/css/Finance/Style/PayrollManagement/payroll_management.css"
import "../../../../assets/css/Finance/Style/PayrollManagement/payroll_management.css"
// import SwipeIndex from "./SwipeIndex"
// import IssuesIndex from "./IssuesIndex"
import "../../../../assets/css/Human Resource/SwipeAndIssues.css"
import LeaveManagement from "./LeaveManagement"
// import WorkFromHome from "./WorkFromHome"

const DevLeaveManagement = () => {
  const [verticalActiveTab, setverticalActiveTab] = useState("1")
  const [fixedSideTab, setFixedSideTab] = useState(false)

  document.addEventListener("scroll", () => {
    if (window.scrollY > 68) {
      setFixedSideTab(true)
    } else {
      setFixedSideTab(false)
    }
  })

  document.title = "Leave Management | Zithas Technologies"

  const toggleVertical = tab => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content mb-4">
        <Container fluid>
          <Breadcrumbs
            title={"Human Resource"}
            breadcrumbItem={"Leave Management"}
          />

          <Row className="gx-4 justify-content-between di-flex align-items-top">
            <Col md="2" className="px-0">
              <Nav
                pills
                className={`side-tab flex-column px-2 py-3
                            ${fixedSideTab ? "fixed-side-tab" : ""} h-100`}
              >
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "1",
                    })}
                    onClick={() => {
                      toggleVertical("1")
                    }}
                  >
                    Leave Management
                  </NavLink>
                </NavItem>
                {/* <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "2",
                    })}
                    onClick={() => {
                      toggleVertical("2")
                    }}
                  >
                    Work from Home
                  </NavLink>
                </NavItem> */}
              </Nav>
            </Col>
            <Col md="10 pe-0 di-flex align-items-top">
              <div className=" bg-transparent mb-0" id="edit-lead">
                <TabContent
                  activeTab={verticalActiveTab}
                  className="text-muted mt- mt-md-0"
                >
                  <TabPane tabId="1">
                    <LeaveManagement verticalActiveTab={verticalActiveTab} />
                  </TabPane>
                  {/* <TabPane tabId="2">
                    <WorkFromHome verticalActiveTab={verticalActiveTab} />
                  </TabPane> */}
                </TabContent>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default DevLeaveManagement
